// libs
import { styled } from '@nykaa/ui-components';

//components
import IOElement from 'shared/components/IOElement';

export const Anchor = styled(IOElement)`
  display: flex;
  justify-content: center;
  text-decoration: none;
  margin: 0 auto;
  width: 110px;
  ${({ theme }) => theme.typography.buttonMedium};
  padding: ${({ theme }) => `${theme.spacing.spacing50} ${theme.spacing.spacing80}`};
  border: 1px solid ${({ theme }) => theme.colors.textOutline};
  border-radius: ${({ theme }) => theme.borders.radius10};
`;
